/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import {useDispatch} from "react-redux";
import React, {useEffect} from "react";
import {setPageTitle} from "../features/common/headerSlice";
import {FormForgotPassword} from "./FormForgotPassword";

export const ResetPassword = () => {


    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setPageTitle({title: "Reset Password"}))
    }, [dispatch])

    return <FormForgotPassword/>

}
